import "@mtc/ui/estilo.css";
import { LimiteDeErro, ProvedorNavegacao, type PropsLink } from "@mtc/ui";
import { capturarNoNavegador, iniciarNoNavegador } from "@mtc/observabilidade/navegador";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Link } from "react-router";
import { App } from "./App";
import { carregarConfig } from "./config";
import { ProvedorSessao } from "./sessao";

/** Links do design system viram links do roteador; externos continuam <a>. */
function LinkDoRoteador({ href, ...p }: PropsLink) {
  return /^(https?:|mailto:)/.test(href) ? <a href={href} {...p} /> : <Link to={href} {...p} />;
}

const raiz = document.getElementById("raiz");
if (!raiz) throw new Error("#raiz nao existe");

carregarConfig()
  .then((cfg) => {
    // Erros e rastreio no Sentry (sem SENTRY_DSN no config.json, nada sai). O rastreio segue so pras nossas APIs.
    iniciarNoNavegador({ app: "painel", dsn: cfg.SENTRY_DSN, ambiente: cfg.AMBIENTE, versao: cfg.VERSAO, apis: [cfg.API_URL, cfg.PAGAMENTOS_URL] });
    createRoot(raiz).render(
      <StrictMode>
        <LimiteDeErro aoErro={(erro, pilha) => capturarNoNavegador(erro, { pilha, caminho: window.location.pathname })}>
        <QueryClientProvider client={new QueryClient()}>
          <BrowserRouter>
            <ProvedorNavegacao link={LinkDoRoteador}>
              <ProvedorSessao apiUrl={cfg.API_URL}>
                <App />
              </ProvedorSessao>
            </ProvedorNavegacao>
          </BrowserRouter>
        </QueryClientProvider>
        </LimiteDeErro>
      </StrictMode>,
    );
  })
  .catch((err: unknown) => {
    raiz.textContent = `Falha ao carregar a configuração: ${err instanceof Error ? err.message : String(err)}`;
  });
